const SESSIONS_CONFIG_KEY = "session";

class SessionService {
    session = {
        currentCompany: {
            company: null,
            office: null,
            all_companies: false
        },
        currentModule: 'OptimumDesk'
    };

    constructor() {

    }

    setCurrentCompany() {

    }

    setCurrentModule() {

    }

    getInitSession() {
        return this.session;
    }

    getSession() {
        const ls = localStorage.getItem(SESSIONS_CONFIG_KEY);

        if (ls) {
            try {
                return JSON.parse(ls);
            } catch (er) {
                console.error(er);
            }
        }

        return this.getInitSession();
    }
}

export default new SessionService();
